<!--
 * @Description: 
 * @Author: 
 * @Date: 2023-09-21 15:51:04
 * @LastEditTime: 2024-03-19 18:47:57
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="left-box-div">
    <div class="title-box01">
      <div class="title-box02">
        <div class="title-name">企业需求</div>
        <!-- <table class="table_data01">
          <tr>
            <td>总收入：</td>
            <td colspan="3" class="font01">123653元</td>
          </tr>
          <tr>
            <td>收入渠道数：</td>
            <td colspan="3" class="font03">5个</td>
          </tr>
          <tr>
            <td>收入最多渠道</td>
            <td class="font04">渠道A(56%)</td>
            <td>收入最少渠道</td>
            <td class="font05">渠道C(2.8%)</td>
          </tr>
          <tr>
            <td>渠道A收入</td>
            <td class="font6">53602元</td>
            <td>渠道A收入占比</td>
            <td class="font6">4.8%</td>
          </tr>
          <tr>
            <td>渠道B收入</td>
            <td class="font6">53602元</td>
            <td>渠道B收入占比</td>
            <td class="font6">4.8%</td>
          </tr>
          <tr>
            <td>渠道C收入</td>
            <td class="font6">53602元</td>
            <td>渠道D收入占比</td>
            <td class="font6">4.8%</td>
          </tr>
        </table> -->

        <div class="scroll-board">
          <dv-scroll-board :config="config" style="width:95%;height:280px" />
        </div>

        <div class="mar-t-10">
          <div
            id="myWaterFall"
            style="width: 100%; height: calc(100vh - 470px)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mianIndex",
  props: {
    // msg: String,
  },
  data() {
    return {
      config: {
        header: [
          "提出方式",
          "企业名称",
          "企业负责人及电话",
          "意见建议具体内容"
        ],
        data: [
          [
            "座谈会面提",
            "重百合川商场",
            "何春",
            "重百合川商场周边环境卫生品质有待提高，特别是商场边上的立信大厦周边。"
          ],
          [
            "座谈会面提/书面",
            "丹信地产",
            "戴敏",
            "原632路公交站点“锦城宾馆”站描述的锦城宾馆因锦城宾馆旧城改造拆除不复存在，原地址已开发为商业综合“锦悦城”项目，且632路公交线路为单循环线路，对耍街及周边群众出行不方便，现申请协调公交站点名“锦城宾馆”变更为“锦悦城”，公交线路为双向线路。"
          ],
          [
            "座谈会面提",
            "财富广场",
            "杨万",
            "针对财富、步步高、耍街整个商圈，道路、灯光、景观等需要进一步提升，且商圈周边摩托车停放过多，急需解决。"
          ],
          [
            "座谈会面提",
            "合州实业",
            "唐勇",
            "为解决交通拥堵问题，建议加快推进行知路建设进度"
          ],
          [
            "座谈会面提",
            "义乌商场",
            "陈建辉",
            "义乌商场修建年代较久，目前想维修市场，但商场又收不了管理费。"
          ],
          [
            "座谈会面提",
            "星艺佳商场",
            "陆露",
            "商场周边摩托车停放过多且占道严重。"
          ],
          [
            "座谈会面提",
            "宝龙城市广场",
            "沈腾",
            "宝龙街区餐饮氛围浓厚，但是宝龙2、3号门客流较少，希望加强对新商铺的帮扶。"
          ]
        ],
        headerBGC: "#3566E3",
        waitTime: 1000
      }
    };
  },
  mounted() {
    console.log(this.$echarts);
    this.getCharts();
  },
  methods: {
    getCharts() {
      const chartBox = this.$echarts.init(
        document.getElementById("myWaterFall")
      );
      const option = {
        color: ["#32C5E9"],
        title: {
          text: "规上工业总产值ToP5",
          textStyle: {
            color: "#e9ebee",
            fontSize: "16"
          },
          subtext: "单位：万元",
          subtextStyle: {
            color: "#e9ebee",
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: ["合川燃气", "永生食品",  "莎公主食品","宏炜食品", "德炜食品"],
          axisLabel: {
            formatter: function(value) {
              var result = "";
              var maxLength = 4; // 每行最多显示3个字符
              for (var i = 0, len = value.length; i < len; i += maxLength) {
                result += value.slice(i, i + maxLength) + "\n";
              }
              return result;
            },
            interval: 0, //横轴信息全部显示
            show: true,
            textStyle: {
              color: "#fff"
            }
          }

          // boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, 0.01],

          axisLabel: {
            //坐标轴刻度标签的相关设置。
            interval: 0,
            rotate: "45",
            textStyle: {
              color: "#fff"
            }
          }
          // data: [
          //   "重庆合川燃气有限责任公司",
          //   "重庆市永生食品有限公司",
          //   "重庆宏炜食品有限公司",
          //   "重庆莎公主食品有限公司",
          //   "重庆德炜食品有限公司",
          // ]
        },
        series: [
          // {
          //   name: "2011",
          //   type: "bar",
          //   data: [18203, 23489, 29034, 104970, 131744, 630230]
          // },
          {
            name: "2024年",
            type: "bar",
            data: [9274, 3201, 1559,1137, 354]
          }
        ]
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        chartBox.resize();
      });
    }
  }
};
</script>

<style scoped>
.left-box-div {
  width: 26%;
}

.title-name {
  width: 44%;
  height: 4%;
  margin: 0 auto;
  font-size: 1em;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table_data01 {
  width: 96%;
  margin-left: 2%;
  border-collapse: collapse;
  color: #ffffff;
  margin-top: 10px;
  text-indent: 3px;
  font-size: 12px;
}

table {
  background-color: transparent;
  border-spacing: 0;
  border-collapse: collapse;
}

.table_data01 tr td {
  border: 1px solid #5bc0de;
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}

.font01 {
  font-size: 30px;
  color: #4cae4c;
}

.font03 {
  font-size: 30px;
  color: #e9a832;
}

.font04 {
  color: #a4e90f;
  font-size: 18px;
}

.font05 {
  color: #e92b23;
  font-size: 18px;
}

.font6 {
  font-weight: bold;
  font-size: 18px;
}

.scroll-board {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/left-box.vue